import { AnimatedDiv } from "@client/content/hocs/animate";
import ErrorBoundary from "@client/controls/ErrorBoundary/component";
import withIsVisibleHOC from "@client/hocs/withIsVisible";
import { getEntityDataAttributes } from "@client/lib/entities";
import { type AnimationOptions } from "@client/lib/jquery/animate";
import classnames from "classnames";
import * as React from "react";
import { type ContainerProps } from "./container";
import InitContainer from "./InitContainer";

export type MapProps = ContainerProps & {
  animationOptions: AnimationOptions;
  moduleType: string;
  children?: any;
  style: React.CSSProperties;
  viewonly?: boolean;
};

export type ItemContainerComponentProps = Omit<MapProps, "moduleType">;

const Container = ({ animationOptions, className, id, moduleType, children, source, viewonly, ...props }: MapProps) => (
  <AnimatedDiv
    {...props}
    animationOptions={animationOptions}
    className={classnames("wsc_content_container flex", className)}
    {...getEntityDataAttributes(id, viewonly)}
  >
    <ErrorBoundary>
      <InitContainer id={id} moduleType={moduleType} source={source}>
        {children}
      </InitContainer>
    </ErrorBoundary>
  </AnimatedDiv>
);

export default withIsVisibleHOC<ItemContainerComponentProps>(Container);
